import { Button, Paper, Popper, Slider, SvgIcon, Typography } from '@mui/material';
import React from 'react';

import { borderRadius, palette, spaces, typography } from '../../../assets/styles/themes/tokens';
import getMuiIcon from '../../../utils/getMuiIcon';

interface SelectZoomProps {
	factor?: number;
	onZoomChange?: (factor: number) => void;
	sliderProps?: {
		max: number;
		min: number;
		step: number;
	};
}

const SelectZoom: React.FC<SelectZoomProps> = (props) => {
	const [isOpen, setOpen] = React.useState(false);
	const anchorEl = React.useRef<HTMLButtonElement>(null);
	const buttonIcon = isOpen ? getMuiIcon('dropdownOpenSmall') : getMuiIcon('dropdownClosedSmall');
	return (
		<>
			<Popper open={isOpen} anchorEl={anchorEl.current} disablePortal>
				<Paper
					elevation={4}
					sx={{
						borderRadius: borderRadius.md,
						paddingX: spaces.xs,
						marginBottom: spaces.sm,
						display: 'flex',
					}}
				>
					<Slider
						step={props.sliderProps?.step}
						marks
						min={props.sliderProps?.min}
						max={props.sliderProps?.max}
						value={props.factor}
						getAriaValueText={(value) => `${value}%`}
						sx={{
							width: '160px',
							'& .MuiSlider-thumb': {
								width: '12px',
								height: '12px',
							},
						}}
						onChange={(_event, value) => {
							if (typeof value === 'number') props.onZoomChange && props.onZoomChange(value);
						}}
					/>
				</Paper>
			</Popper>
			<Button
				size="medium"
				variant="text"
				ref={anchorEl}
				onClick={() => setOpen(!isOpen)}
				sx={{
					paddingRight: 0,
					width: '56px',
				}}
			>
				<Typography
					sx={{
						...typography.button.small,
					}}
				>
					{props.factor}%
				</Typography>
				<SvgIcon
					sx={{
						color: palette.action.active,
					}}
					component={buttonIcon}
				/>
			</Button>
		</>
	);
};

export default SelectZoom;
